{
    "accept": "Acceptera",
    "action_open_in_external_app": "Öppna i ${1}",
    "all": "Alla",
    "apply": "Tillämpa",
    "back": "Tillbaka",
    "cancel": "Avbryt",
    "choose": "Välj",
    "clear": "Rensa",
    "clear_all": "Rensa alla",
    "clear_filters": "Rensa filter",
    "client_offline_error_description": "Du är inte uppkopplad. Kontrollera din internetanslutning och försök igen.",
    "client_offline_error_title": "Ingen internetanslutning",
    "client_timeout_error_description": "Vi kunde inte slutföra din begäran på grund av en timeout i anslutningen. Vänligen kontrollera din anslutning och försök igen. Om problemet kvarstår finns vårt supportteam här för att hjälpa till.",
    "client_timeout_error_title": "Anslutningen är tidsbegränsad.",
    "content_missing": "Innehållet saknas.",
    "delete": "Radera",
    "description": "Beskrivning",
    "dismiss": "Avvisa",
    "done": "Klar",
    "donor_feedback_anonymized": "Vi har redan anonymiserat dina uppgifter på grund av dataskyddsskäl.",
    "donor_feedback_incorrect_link": "Den länk du använder är inte korrekt - kontrollera att du använder den fullständiga länken som skickats till dig.",
    "donor_feedback_not_found": "Tyvärr är den här länken ogiltig, detta kan ha någon av följande orsaker:",
    "error_occurred": "Ett fel inträffade",
    "expired": "Är inte ikraft",
    "failed": "Misslyckades",
    "field_address_search_accuracy_hint": "Förbättra sökresultaten genom att ge appen tillgång till din plats via inställningarna i operativsystemet.",
    "field_error_address_unsupported_country": "Adressen finns inte i ett giltigt land",
    "field_error_any": "Ange minst ett av dessa fält: ${1}",
    "field_error_date_invalid": "Vänligen ange ett giltigt datum",
    "field_error_date_max": "Datumet måste vara ${1} eller tidigare",
    "field_error_date_min": "Datumet måste vara ${1} eller senare",
    "field_error_date_range_max": "Datumet måste vara före ${1}",
    "field_error_date_range_min": "Datumet måste vara efter ${1}",
    "field_error_email": "Vänligen ange en giltig e-postadress",
    "field_error_length_max": "Detta fält är begränsat till ${1} tecken",
    "field_error_length_min": "Vänligen ange minst ${1} tecken",
    "field_error_max": "Det högsta värdet är ${1}",
    "field_error_min": "Det lägsta värdet är ${1}",
    "field_error_pattern": "Inmatningen är ogiltig",
    "field_error_phone_invalid": "Vänligen ange ett giltigt telefonnummer",
    "field_error_phone_starts_with_zero": "En landskod finns redan. Vänligen ta bort det inledande \"0\" från telefonnumret.",
    "field_error_required": "Vänligen fyll i detta fält",
    "field_is_required": "Detta fält är obligatoriskt",
    "field_placeholder_address_search": "Ange en plats",
    "field_select_not_found": "${1}' kunde inte hittas",
    "font_big": "stor font",
    "font_medium": "medium font",
    "font_small": "liten font",
    "last_attempt": "Sista försöket",
    "last_upload": "Senaste uppladdning",
    "link_sent": "Länk skickad, vänligen kontrollera",
    "network_error": "Fel i nätverket",
    "network_error_cookies_disabled_description": "Det ser ut som om du har inaktiverat alla cookies? Prova kanske en annan webbläsare",
    "network_error_cookies_disabled_title": "Cookies inaktiverade",
    "next": "Nästa",
    "no_results": "Inga resultat",
    "offline": "offline",
    "ok": "OK",
    "online": "online",
    "open": "Öppna",
    "page_not_found_description": "Den websida du försökte begära finns inte. Du kan ha skrivit fel URL adress",
    "page_not_found_link": "Återgå till startsidan.",
    "page_not_found_title": "Sidan hittades inte",
    "pagination_result": "${1} - ${2} av ${3} Resultat",
    "passed": "Godkänd",
    "request_support": "Begär support",
    "request_support_error_title": "Begäran misslyckades",
    "request_support_success_description": "Vi har mottagit din supportbegäran.",
    "request_support_success_title": "Begäran mottagen",
    "reset_filters_description": "Försök att justera din sökning eller dina filter.",
    "result": "Resultat",
    "retry": "Försök igen",
    "save": "Spara",
    "select_group_selected": "Valda",
    "send_a_support_request": "Begäran om support",
    "server_unavailable_error_description": "Tjänsten är tillfälligt otillgänglig. Vänligen kontrollera igen senare.",
    "server_unavailable_error_title": "Tjänsten är inte tillgänglig",
    "server_unexpected_error_description": "Något gick fel på vår sida. Vänligen försök igen om en stund. Om problemet kvarstår, vänligen kontakta vår support.",
    "server_unexpected_error_title": "Ett oväntat fel uppstod.",
    "state_done": "Klar",
    "state_not_uploaded": "Inte uppladdad",
    "state_pending": "Väntar",
    "state_refused": "Avböjde",
    "state_uploading": "Laddar upp",
    "submit": "Skicka",
    "support_request_type": "Typ",
    "support_request_type_crash": "Krasch",
    "support_request_type_critical": "Kritisk",
    "support_request_type_minor": "Liten sak",
    "support_request_type_other": "Annat",
    "toggle_detail_view": "Detaljvy",
    "toggle_list_view": "Se lista",
    "type": "Typ",
    "unknown_error": "Något gick fel",
    "unknown_error_description": "Ett oväntat fel har inträffat. Vänligen försök igen. Om problemet kvarstår, kontakta support.",
    "uploading": "Laddar up...",
    "validating": "Vänta, vi ska bara se till att allt är korrekt..."
}